var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Checkbox, FormControl, ListItemText, MenuItem, Select } from '@mui/material';
import Text from '../Text';
import React from 'react';
var ITEM_HEIGHT = 48;
var ITEM_PADDING_TOP = 8;
var FilterText = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 6px;\n  left: 12px;\n"], ["\n  position: absolute;\n  top: 6px;\n  left: 12px;\n"])));
var MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};
var FilterWithCheck = function (props) {
    var items = props.items, title = props.title, onChange = props.onChange, _a = props.styles, styles = _a === void 0 ? {} : _a;
    var _b = React.useState([]), selectedItem = _b[0], setSelectedItem = _b[1];
    var handleChange = function (event) {
        var value = event.target.value;
        var selected = typeof value === 'string' ? value.split(',') : value;
        setSelectedItem(selected);
        onChange(selected);
    };
    return (_jsx("div", { children: _jsxs(FormControl, __assign({ sx: __assign({ m: 1 }, styles) }, { children: [_jsx(FilterText, { children: _jsxs(Text, { children: [title, " ", selectedItem.length > 0 && "(".concat(selectedItem.length, ")")] }) }), _jsx(Select, __assign({ sx: { borderRadius: '0px', height: '36px' }, multiple: true, value: selectedItem, onChange: handleChange, renderValue: function () { return ''; }, MenuProps: MenuProps }, { children: items.map(function (item) { return (_jsxs(MenuItem, __assign({ style: { height: '40px' }, value: item.value }, { children: [_jsx(Checkbox, { checked: selectedItem.indexOf(item.value) > -1 }), _jsx(ListItemText, { primary: item.text })] }), item.value)); }) }))] })) }));
};
export default FilterWithCheck;
var templateObject_1;
